export default "__VITE_ASSET__BB7OCuY6__"